export default __webpack_public_path__ + "static/tplink-2bb6114c9854450511066b19f3f797b9.png";